import { Box, Center, Icon, SkeletonCircle } from '@/components';
import ArrowLeft from '@/svgs/ArrowLeft.svg';
import ArrowRight from '@/svgs/ArrowRight.svg';

const SkeletonPagination: React.FC = () => {
  return (
    <Box mb={2}>
      <Center mb={3}>
        <Icon as={ArrowRight} fill="gray.700" ml="8" />
        {Array(5)
          .fill(1)
          .map((_item, index) => (
            <SkeletonCircle
              w={{ base: 7.5, md: 8 }}
              h={{ base: 7.5, md: 8 }}
              key={index}
              mr={2}
              ml={index === 4 ? 2 : 0}
            />
          ))}
        <Icon as={ArrowLeft} fill="gray.700" mr="8" />
      </Center>
    </Box>
  );
};
export default SkeletonPagination;
